import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import "./index.scss";

const ChevronLeftIcon = () => (
    <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
    >
        <path d="M15 6l-6 6 6 6" />
    </svg>
);

/**
 * Back navigation button. Defaults to a labelled pill ("‹ Back …"); set
 * `iconOnly` to render just the chevron in a circle (the compact form used in
 * the mobile app header on the Band and Chat pages). The label is always passed
 * for the accessible name and is visually hidden in the icon-only form.
 */
export default function BackButton({ label, onClick, iconOnly = false, className = "" }) {
    return (
        <button
            type="button"
            className={classNames("back-button", iconOnly && "back-button--icon-only", className)}
            onClick={onClick}
            aria-label={label}
        >
            <ChevronLeftIcon />
            <span className="back-button__label">{label}</span>
        </button>
    );
}

BackButton.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    iconOnly: PropTypes.bool,
    className: PropTypes.string,
};

BackButton.defaultProps = {
    onClick: undefined,
    iconOnly: false,
    className: "",
};
